<template>
  <div>
    <data-table
      ref="table"
      :fetch-from="fetchForm"
      :fields="fields"
    >
      <template
        slot="actions"
        slot-scope="slotData"
      >
        <v-btn
          x-small
          color="primary"
          @click="showDetails(slotData.rowData)"
        >Edit</v-btn>
      </template>

    </data-table>
    <actions v-if="canEdit()">
      <v-btn
        color="primary"
        class="mr-4"
        small
        @click="showAddDialog()"
      >
        Add new
      </v-btn>
    </actions>
    <empty-space />
    <modal-form
      title="Shelter"
      :show="dialog"
      @update:show="dialog=$event"
      v-on:saveData="doSave"
      :readonly="isReadOnly()"
    >
      <v-container>
        <v-form v-model="valid">
          <v-row>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnly()"
                label="Shelter type"
                :value="getValue(item, 'shelter_type')"
                @input="setValue(item, 'shelter_type', $event)"
              ></text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <s-textarea
                :readonly="isReadOnly()"
                label="Comments"
                :value="getValue(item, 'comments')"
                @input="setValue(item, 'comments', $event)"
              ></s-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </modal-form>
  </div>
</template>

<script>
  import DataTable from '@/components/DataTable'
  import Actions from '@/components/Actions'
  import EmptySpace from '@/components/EmptySpace'
  import BatteryType from '@/components/codelist/BatteryType'
  import BatteryStatus from '@/components/codelist/BatteryStatus'
  import InstalledIn from '@/components/codelist/InstalledIn'
  import TowerDesigner from '@/components/codelist/TowerDesigner'
  import TextField from '@/components/TextField'
  import TowerManufacturer from '@/components/codelist/TowerManufacturer'
  import STextarea from '@/components/Textarea'
  import ModalForm from '@/components/ModalForm'
  import DatePicker from '@/components/DatePicker'
  import NewUsed from '@/components/codelist/NewUsed'
  import ReactivitMixin from '@/mixins/Reactivity'
  import DisplayField from '@/components/DisplayField'
  import PermissionsMixin from '@/mixins/Permissions'
  import ConstructionShelterService from '@/services/construction-shelter'

  export default {
    name: 'Shelter',
    mixins: [
      ReactivitMixin,
      PermissionsMixin,
    ],
    components: { DisplayField, NewUsed, DatePicker, ModalForm, STextarea, TowerManufacturer, TextField, TowerDesigner, InstalledIn, BatteryStatus, BatteryType, EmptySpace, Actions, DataTable },
    props: {
      site: {
        default: undefined,
      },
    },
    data: function () {
      return {
        dialog: false,
        item: {},
        fields: [
          {
            name: 'shelter_type',
            title: 'Shelter Type',
          },
          {
            name: 'tower_type',
            title: 'Tower type',
          },
          {
            name: 'tower_production_year',
            title: 'Production year',
          },
          {
            name: '__slot:actions',
            title: 'Actions',
          },
        ],
        section: 'construction_equipment',
      }
    },
    computed: {
      isEditing () {
        return this.item.id !== undefined
      },
    },
    methods: {
      fetchForm (urls, options) {
        const dcs = new ConstructionShelterService(this.site.id)
        return dcs.list(options.params)
      },
      showAddDialog () {
        this.item = {}
        this.dialog = true
      },
      showDetails (item) {
        this.item = JSON.parse(JSON.stringify(item))
        this.dialog = true
      },
      doSave () {
        if (this.isEditing) {
          const acs = new ConstructionShelterService(this.site.id)
          acs.put(this.item.id, this.item).finally(() => {
            this.$refs.table.refresh()
            this.dialog = false
          })
        } else {
          const acs = new ConstructionShelterService(this.site.id)
          acs.post(this.item).finally(() => {
            this.$refs.table.refresh()
            this.dialog = false
          })
        }
      },
    },
  }
</script>

<style scoped>

</style>
